import classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { TCustomAction } from '../../../types/customActions';

export enum EUserCardMenuItemType {
  Spam = 'spam',
  Archive = 'archive',
}

export type TUserCardMenuItem = {
  title: JSX.Element;
  handler(currentChatId: string): void;
  type: EUserCardMenuItemType | TCustomAction;
};

type TUserCardMenuContent = {
  currentChatId: string;
  menuItems: TUserCardMenuItem[];
};

export const UserCardMenuContent: React.VFC<TUserCardMenuContent> = ({ currentChatId, menuItems }) => {
  const items = React.useMemo(
    () =>
      menuItems.map(({ title, handler, type }, index) => (
        <li
          key={index}
          data-testid="UserCardMenuItem"
          className={classNames(styles['item'], type === EUserCardMenuItemType.Spam && styles['item__red'])}
          onClick={() => {
            handler(currentChatId);
          }}
        >
          {title}
        </li>
      )),
    [currentChatId, menuItems],
  );

  return (
    <ul className={styles['menu']} data-testid="UserCardMenuContent">
      {items}
    </ul>
  );
};
